import { Text, TextDescription, TextTitle } from "../components/Texts";
import { useDispatch, useSelector } from "react-redux";

import Column from "../components/Column";
import DateFormatter from "../modules/utils/DateFormatter";
import DatePicker from "../components/DatePicker";
import Dropdown from "../components/Dropdown";
import Icon from "../components/Icon";
import React from "react";
import Row from "../components/Row";
import Section from "../components/Section";
import Separator from "../components/Separator";
import Table from "../components/Table";
import Trending from "components/performance/Trending";
import _find from "lodash/find";
import _forEach from "lodash/forEach";
import _get from "lodash/get";
import _orderBy from "lodash/orderBy";
import colors from "../styles/colors";
import { compose } from "redux";
import formatMetricValue from "../modules/utils/formatMetricValue";
import formatNumber from "../modules/utils/formatNumber";
import mainSelectors from "../modules/main/selectors";
import moment from "moment";
import performanceAction from "../modules/performance/actions";
import performanceSelectors from "../modules/performance/selectors";
import styled from "styled-components";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useWindowSize from "../layout/useWindowSize";
import withUserPerm from "services/withUserPerm";
import TopBar from "../components/TopBar";

const Performance = () => {
  //eslint-disable-next-line no-unused-vars
  const [t] = useTranslation();
  const [selectedView, setSelectedView] = useState({
    title: t("__daily"),
    value: "daily",
  });
  const currentAd = useSelector((state) => mainSelectors.currentAd(state));
  const performanceList = useSelector((state) => performanceSelectors.performanceList(state));
  const dispatch = useDispatch();
  const viewOptions = [
    {
      title: t("__daily"),
      value: "daily",
    },
    {
      title: t("__weekly"),
      value: "weekly",
    },
    {
      title: t("__monthly"),
      value: "monthly",
    },
  ];
  const cusId = currentAd.ads_account_id;
  const date = moment().format("YYYY-MM-DD");

  const onViewSelected = (item) => {
    setSelectedView(item);
    getPerformanceList(item.value);
  };

  const getPerformanceList = (view) => {
    dispatch(performanceAction.GetPerformanceList(cusId, date, view));
  };

  useEffect(() => {
    dispatch(performanceAction.GetPerformanceList(cusId, date, selectedView.view));
  }, [cusId, date, selectedView.view, dispatch]);

  console.log("getPerformanceList", performanceList);

  return (
    <div>
      <StyledContainerTop useWindowSize={useWindowSize()}>
        <StyledContainerTopBar useWindowSize={useWindowSize()}>
          <TopBar title={t("__account_performance")} />
        </StyledContainerTopBar>
        <DatePicker items={viewOptions} onSelected={onViewSelected} />
      </StyledContainerTop>
      {
        <>
          <Trending dataList={performanceList} view={selectedView} />
          <AllMetrics dataList={performanceList} view={selectedView} />
          <Row margin="0 0 24px" columnSpacing="0" responsive>
            <Column>
              <Comparison dataList={performanceList} view={selectedView} />
            </Column>
            <Column />
          </Row>
        </>
      }
    </div>
  );
};

export default compose(withUserPerm())(Performance);

const AllMetrics = ({ dataList, view }) => {
  //eslint-disable-next-line no-unused-vars
  const isMobile = useWindowSize().width < 768;
  const [t] = useTranslation();
  const [selectedSortOption, setSelectedSortOption] = useState({ key: "date", direction: "desc" });
  let formatDate = DateFormatter.formatDateFull;

  if (view.value === "monthly") {
    formatDate = DateFormatter.formatMonthYear;
  }

  const metrics = ["click", "impression", "cost", "ctr", "cpc", "conversion"];
  const data = _orderBy(
    dataList.map((item) => {
      const info = {
        _date: item.startDate,
        date: (
          <TextTitle size="10px" date={isMobile}>
            {view.value === "weekly"
              ? `${formatDate(item.startDate)} - ${formatDate(item.endDate)}`
              : formatDate(item.startDate)}
          </TextTitle>
        ),
      };
      _forEach(metrics, function (metric) {
        info[`_${metric}`] = item.data[metric] || 0;
        info[metric] = formatMetricValue(metric, item.data[metric] || 0);
      });
      return info;
    }),
    [`_${selectedSortOption.key}`],
    [selectedSortOption.direction],
  );

  console.log("AllMetrics", view, selectedSortOption, data);

  const tableColumns = [
    {
      key: "date",
      title: view.value === "monthly" ? t("__month") : t("__date"),
      options: {
        width: "160px",
        strongText: true,
        fontSize: "10px",
      },
    },
    {
      key: "cost",
      title: t("__cost"),
      options: {
        align: "right",
      },
    },
    {
      key: "click",
      title: t("__clicks"),
      options: {
        align: "right",
      },
    },
    {
      key: "impression",
      title: t("__impressions"),
      options: {
        align: "right",
      },
    },
    {
      key: "ctr",
      title: t("__ctr"),
      options: {
        align: "right",
        width: "60px",
      },
    },
    {
      key: "cpc",
      title: t("__cpc"),
      options: {
        align: "right",
      },
    },
    {
      key: "conversion",
      title: t("__conversion"),
      options: {
        align: "right",
      },
    },
  ];

  const sortOptions = {
    ...selectedSortOption,
    onSelected: setSelectedSortOption,
  };

  return (
    <Section margin="0 0 24px">
      <Table columns={tableColumns} data={data} responsiveColumns={2} maxHeight="280px" sortOptions={sortOptions} />
    </Section>
  );
};

const Comparison = ({ dataList, view }) => {
  //eslint-disable-next-line no-unused-vars
  const [t, i18n] = useTranslation();
  const [date1, setDate1] = useState();
  const [date2, setDate2] = useState();
  let date1Data = {},
    date2Data = {};

  if (!dataList || !dataList.length) return null;

  //console.log("Comparison d1 d2", date1, date2);

  date1Data = date1 ? _find(dataList, { startDate: date1 }) : dataList[dataList.length - 2];
  date2Data = date2 ? _find(dataList, { startDate: date2 }) : dataList[dataList.length - 1];

  if (!date1Data || !date2Data) {
    date1Data = dataList[dataList.length - 2];
    date2Data = dataList[dataList.length - 1];
  }

  const formatDate = (startDate, endDate) => {
    if (view.value === "weekly") {
      return `${DateFormatter.formatDateFull(startDate)} - ${DateFormatter.formatDateFull(endDate)}`;
    } else if (view.value === "monthly") {
      return DateFormatter.formatMonthYear(startDate);
    } else {
      return DateFormatter.formatDateFull(startDate);
    }
  };

  date1Data.label = formatDate(date1Data.startDate, date1Data.endDate);
  date2Data.label = formatDate(date2Data.startDate, date2Data.endDate);

  const dropdownItems = _orderBy(dataList, ["startDate"], ["desc"]).map((item) => {
    return {
      title: formatDate(item.startDate, item.endDate),
      value: item.startDate,
    };
  });

  const date1Button = ({ onClick }) => (
    <div className="custom-dropdown-button" onClick={onClick}>
      <TextTitle size="12px" date>
        {date1Data.label}
      </TextTitle>
      <Icon name="icon-down-dir" size="16px" />
    </div>
  );

  const date2Button = ({ onClick }) => (
    <div className="custom-dropdown-button" onClick={onClick}>
      <TextTitle size="12px" date>
        {date2Data.label}
      </TextTitle>
      <Icon name="icon-down-dir" size="16px" />
    </div>
  );

  //console.log("Comparisons", dropdownItems);

  const metrics = [
    {
      title: t("__cost"),
      key: "cost",
    },
    {
      title: t("__clicks"),
      key: "click",
    },
    {
      title: t("__impressions"),
      key: "impression",
    },
    {
      title: t("__ctr"),
      key: "ctr",
    },
    {
      title: t("__cpc"),
      key: "cpc",
    },
    {
      title: t("__conversion"),
      key: "conversion",
    },
  ];

  const data = metrics.map((metric) => {
    const d1Val = _get(date1Data, ["data", metric.key]) || 0;
    const d2Val = _get(date2Data, ["data", metric.key]) || 0;
    let change = ((d2Val - d1Val) / d1Val) * 100;
    if (change > 0) {
      change = <Text color={colors.positive} size="10px">{`+${formatNumber(change)}%`}</Text>;
    } else if (change < 0) {
      change = <Text color={colors.negative} size="10px">{`${formatNumber(change)}%`}</Text>;
    } else {
      change = null;
    }
    return {
      metric: metric.title,
      date1: formatMetricValue(metric.key, d1Val),
      date2: (
        <>
          <Text size="12px">{formatMetricValue(metric.key, d2Val)}</Text>
          {change}
        </>
      ),
    };
  });

  const tableColumns = [
    {
      key: "metric",
      title: t("__metrics"),
      options: {
        strongText: true,
        width: "90px",
      },
    },
    {
      key: "date1",
      title: (
        <Dropdown
          CustomDropdownButton={date1Button}
          items={dropdownItems}
          onSelected={(item) => setDate1(item.value)}
          position={{ right: "-8px" }}
          minWidth={view.value === "weekly" ? "200px" : "150px"}
        />
      ),
      options: {
        align: "right",
      },
    },
    {
      key: "date2",
      title: (
        <Dropdown
          CustomDropdownButton={date2Button}
          items={dropdownItems}
          onSelected={(item) => setDate2(item.value)}
          position={{ right: "-8px" }}
          minWidth={view.value === "weekly" ? "200px" : "150px"}
        />
      ),
      options: {
        align: "right",
      },
    },
  ];
  return (
    <Section margin="0">
      <TextTitle>{t("__comparison")}</TextTitle>
      <TextDescription>{t("__comparison_period")}</TextDescription>
      <Separator />
      <Table columns={tableColumns} data={data} />
    </Section>
  );
};

const EmptyContent = () => {
  const [t] = useTranslation();
  return (
    <StyledEmptyContainer>
      <p>{t("__no_data")}</p>
    </StyledEmptyContainer>
  );
};

const StyledEmptyContainer = styled.div`
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.descriptionText};
`;

const StyledContainerTop = styled.div.attrs((props) => ({
  display: props.useWindowSize.width < 835 ? "block" : "flex",
}))`
  display: ${(props) => props.display};
  justify-content: space-between;
  margin-bottom: 24px;
  display: ;
`;

const StyledContainerTopBar = styled.div.attrs((props) => ({
  display: props.useWindowSize.width < 835 ? "none" : "block",
}))`
  display: ${(props) => props.display};
`;
